import React from "react";
import WorkshopCard from "./WorkshopCard";
import { MODEL } from "../../model";

const Workshops = () => {
  return (
    <section id="workshops" className="workshops">
      <div className="workshops__top">
        <div className="workshops__top__left w-60">
          <h2>Workshops</h2>
        </div>
        <div className="workshops__top__right w-40">
          {/* <Link to="#">See All</Link> */}
        </div>
      </div>

      <ul className="workshops__list">
        {MODEL.data.workshops.map((item) => (
          <WorkshopCard key={item.id} item={item} />
        ))}
      </ul>
    </section>
  );
};

export default Workshops;
